export default __webpack_public_path__ + "static/media/problema-06.68c3fbb5.webp";